<template>
  <div>
    <div class="el-row process-body" v-if="!loading"  v-loading="loading">
      <!-- {{ selectedNode.users && selectedNode.users.length }} -->
      <div class="el-col el-col-14 process-form-content">
        <div :class="processTitleClasses">{{form.templateName}}</div>
        <div v-if="form.remark" class="process-remark">
          <el-icon class="el-icon-warning-outline"></el-icon>{{form.remark}}
        </div>
        <!-- {{formData}} -->
         <!-- {{forms}} -->
        <history-templates v-if="$route.query.type !== 'edit'" :template-id="form.id" :disabled="loading" @select="applyHistory" @busy="historyLoading=$event" />
        <form-render :key="formEpoch" class="process-form" ref="form" :forms="displayForms" v-model="formData"/>
      </div>
      <div class="el-col el-col-10 process-timeline">
        <div>
          <!-- {{cc}} -->
          <div class="title-timeline">审批流程</div>
          <el-timeline class="my-timeline">
            <el-timeline-item v-for="(activity, index) in cc"
              :key="index"
              :icon="activity.icon"
              size="large"
              class="task">
              <div class="process-node-content" v-if="!activity.hasOwnProperty('options')">
                <div class="process-node-title">
                  <div class="node-title">{{ activity.title }}</div>
                  <div class="node-desc">{{activity.desc}}</div>
                  <div class="node-desc">{{activityMode(activity)}}</div>
                </div>
                <div class="process-node-con"  :class="{ 'process-node-con-single': !activity.multiple }">
                  <!-- {{processUsers}} -->
                   <!-- {{ activity }} -->
                   <!-- 审批人、办理人为空显示 -->
                   <div v-if="activity.nobodyText" class="no-user" > 
                      <div class="item-user" >
                          <div class="user-photo" >
                            <img src="~@/assets/def_avatar_84px.png" class="avatar"  alt="">
                          </div>
                      </div>
                      <div><span class="hot">{{activity.nobodyTitle}}</span>,{{ activity.nobodyText }}</div>
                   </div>
                   <div class="item-user" v-if="activity.users && activity.users.length>6" @click="lookMore(activity.users)">
                      <div class="user-photo" >
                        <img src="~@/assets/img/formDesign/icon_shenpiren.png" class="avatar look-more"  alt="">
                      </div>
                      <div class="look-more">查看全部</div>
                   </div>
                   <!-- 这里最多只输出6条数据 -->
                  <div class="item-user" v-for="(user, index) in activity.users" :key="index" :title="(user.serial||'') + (user.name || user.reallyName)" v-if="index<6">
                      <div class="user-photo" >
                        <!-- {{ activity.multiple }} -->
                        <!-- <img v-if="user.avatarUrl" :src="user.avatarUrl" class="avatar" alt=""> -->
                        <img src="~@/assets/def_avatar_84px.png" class="avatar" alt="">
                        <i class="close el-icon-close" v-if="!user.disabled && activity.isEdit" @click="delUser(activity.users, index,activity.id)"></i>
                        <template v-if="index < Math.min(activity.users.length - 1, 5) || activity.isEdit">
                          <div class="i-and" v-if="activity.mode === 'AND'">+</div>
                          <div class="i-or" v-else-if="activity.mode === 'OR'">/</div>
                        </template>
                      </div>
                      <div class="name-con">
                        <div v-if="user.serial" class="serial">{{user.serial}}</div>
                        <div class="name ellipsis">{{ user.roleName || user.name || user.reallyName }}</div>
                      </div>
                  </div>
                  <div class="add-user" v-if=" activity.isEdit && (activity.multiple || 0 === activity.users.length)" @click="addUser(activity)"><i class="el-icon-plus"></i></div>
                </div>
              </div>
              <el-radio-group v-model="activity.id" size="mini" v-else>
                <el-radio-button :label="d.title" :value="d.id" v-for="(d, index) in activity.options" :key="index"></el-radio-button>
              </el-radio-group>
              <div class="err-tips" v-if="activity.isEmpty">请选择{{ activity.title }}</div>
            </el-timeline-item>
          </el-timeline>
        </div>
        <!-- <org-picker
          :type="this.selectedNode.type || 'user'"
          :multiple="this.selectedNode.multiple || !1"
          ref="orgPicker"
          :selected="this.selectedNode.users || []"
          @ok="selected"
        ></org-picker> -->
        
      </div>
    </div>
    <org-picker title="指定成员" :multiple="this.selectedNode.multiple || !1" ref="orgPicker" @ok="selected" />
    <pop-user-more title="查看全部" ref="popUserMore"/>
  </div>
</template>

<script>
import FormRender from '@/pages/officeApproval/common/form/FormRender'
import HistoryTemplates from './HistoryTemplates'
// import { getFormDetailV2 } from "@/api/design";
import OrgPicker from "@/components/OrgPicker";
import popUserMore from "@/components/popUserMore";
import formItemPermission from '@/pages/officeApproval/approvalList/mixins/formItemPermission.js'
import templateRemark from '@/pages/officeApproval/common/form/templateRemark'

const { filterDuplicateTemplateRemark } = templateRemark

export default {
  name: "SponsorProcess",
  mixins: [formItemPermission],
  components: { FormRender, OrgPicker,popUserMore, HistoryTemplates },
  // props: {
  //   code: {
  //     type: String,
  //     required: true,
  //   },
  // },
  data() {
    return {
      loading: false,
      historyLoading: false,
      formEpoch: 0,
      formData: {},
      select: [],
      selectedNode: {},
      processUsers: {},
      defaultUserIds:[],
      form: {
        formId: "",
        formName: "",
        logo: {},
        formItems: [],
        process: {},
        remark: "",
      },
      loginUser: {},
      conditionFormItem: new Set(),
      activities: [],
      cc: [],
      currentId:'',
      joinDateId:'',
      joinDate:'',
    };
  },
  created(){
  },
  activated() {
    this.loadFormInfo();
  },
  mounted() {
    this.loadLoginUser();
    // this.loadFormInfo(this.code);
  },
  watch: {
    // 被侦听的变量count
    // formData: {
    //   // 对对象进行深度监听
    //   handler(nv) {
    //     this.startProcess(nv, (this.cc = []));
    //   },
    //   immediate: true,
    //   deep: true,
    // },
    // '$route.query.id':{
    //     handler:'loadFormInfo',
    //     immediate:true
    //   }
  },
  computed: {
    forms() {
      return this.$store.state.design.formItems;
    },
    displayForms() {
      return filterDuplicateTemplateRemark(this.forms, this.form.remark)
    },
    // 判断this.form数组第一个元素是否说明文字
    processTitleClasses() {
      return {
        'process-title': true,
        'process-has-description': this.displayForms[0] && this.displayForms[0].icon === "icon-shuoming"
      };
    },
    _value: {
      get: function () {
        return this.value;
      },
      set: function (e) {
        this.$emit("input", e);
      },
    },
  },
  methods: {
    applyHistory(data) {
      if(data.processDefinitionId !== this.form.processDefinitionId){
        this.$message.warning('审批模板已更新，请重新打开后选择历史');return;
      }
      this.formData=JSON.parse(JSON.stringify(data.formData || {}));
      this.formEpoch++;
      this.$message.success('历史内容已带入，请核对修改后提交');
    },
    activityMode(item){
      let count = ''
      let text = ''
      if(item.users && item.users.length > 1){
        count = item.users.length + '人'
        if(item.mode === 'AND'){
          text = '会签'
        }else if(item.mode === 'OR'){
        text = '或签'
        }
      }
      
      return count + text;
    },
    loadLoginUser() {
      this.loginUser = JSON.parse(sessionStorage.getItem("userInfo"));
      if(this.loginUser.reallyName){
        let temp = this.splitString(this.loginUser.reallyName)
        this.loginUser.name = temp.name
        this.loginUser.serial = temp.serial
      }
    },
    // 将 E-Ⅱ-0011中文名字 分成 姓名和工号
    splitString(input) {
      const chineseRegex = /[\u4e00-\u9fa5]+/;
      const chineseMatch = input.match(chineseRegex);
      if (chineseMatch) {
        const name = chineseMatch[0];
        const serial = input.replace(chineseRegex, '');
        return { name, serial };
      } else {
        return { name: '', serial: input };
      }
    },
     loadFormInfo() {
      let id = this.$route.query.id
      if(!id) return false
      const postData = {
        id
      };
      this.loading = true;
      console.log('workflowTemplateDetail:',postData)
      this.$api.workflowTemplateDetail(postData)
        .then((res) => {
          
          let form = res.data;
          console.log('form:',form);
          // form.logo = JSON.parse(form.logo);
          form.settings = JSON.parse(form.settings);
          form.formItems = JSON.parse(form.formItems);
          form.process = JSON.parse(form.process);

          // 有入职的，自动获取
          let joinDate = form.formItems.find(e=>e.name=='JoinDate')||{}
          this.joinDateId = joinDate.id
          if(this.joinDateId){
            this.axios.get('/oa/sys/user').then((res) => {
                console.log(res)
                if (res.code == 0) {
                    this.joinDate = res.data && res.data.employeeDate
                    if (!this.joinDate) {
                      this.$message.warning('请先设置入职日期')
                    }
                    joinDate.props.placeholder = this.joinDate
                    console.log('有入职的，自动获取>>',joinDate)
                  this.initForm(form)
                }
            })            
          }else{
            this.initForm(form)
          }
          

        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
      // getFormDetailV2(formId)
      //   .then((rsp) => {
      //     this.loading = false;
      //     let form = rsp.data.result;
      //     form.logo = JSON.parse(form.logo);
      //     form.settings = JSON.parse(form.settings);
      //     form.formItems = JSON.parse(form.formItems);
      //     form.process = JSON.parse(form.process);


      //     this.form = form;
      //     //构建表单及校验规则
      //     this.$store.state.design = form;
      //     this.startProcess(form.process, this.formData);
      //   })
      //   .catch((err) => {
      //     this.loading = false;
      //     this.$message.error(err);
      //   });
    },
    // 初始表单数据
    initForm(form) {
      this.form = form;
          //构建表单及校验规则
          // this.$store.state.design = form;
          // console.log('发起审批权限问题：',form)
          let permList = this.findNodePermission(form.process,'root')
           // 发起审批，非说明文字，只读状态改成隐藏
           permList.forEach(item => {
            if (item.icon !== 'icon-shuoming' && item.icon !== 'icon-ruzhi') {
              if(item.perm === 'R'){
                item.perm = 'H'
              }
            }
            if (item.icon === 'icon-ruzhi') {
              item.value = this.joinDate
            }
          });
          console.log('>>',permList)
          form.formItems = this.mergePermissions(form.formItems,permList)
          // console.log('permList:',permList)
          this.$store.commit("setDesignForm", form);
          if(this.$route.query.type==='edit'){
            this.formData = this.$store.state.editForm;
          }else{
            this.formData = {};
          }
          this.startProcess(form.process, this.formData);
          
          console.log('流程详情：',form)
          this.loading = false;
          this.$emit('detail',{
            footer:true
          }) 
    },
    validate(call) {
      this.$refs.form.validate(call);
    },
    resetForm() {
      console.log('>>',this.$refs.form)
      // 重置表单
      this.formData = {};
      // this.$refs.form.resetFields();
    },
    getFormData() {
      if (this.joinDateId) {
        this.formData[this.joinDateId] = this.joinDate
      }
      return this.formData;
    },
    resetProcessUser() {
      this.$set(this, 'processUsers', {});
    },
    // 过滤掉不可修改的用户和默认人员
    getProcessUser() {
      console.log('返回：',this.processUsers,this.defaultUserIds)
      return Object.keys(this.processUsers).reduce((acc, key) => {
        acc[key] = this.processUsers[key].filter(user => !user.disabled && !this.defaultUserIds.includes(user.id));
        return acc;
      }, {});
    },
    getForm() {
      return this.form;
    },
    addUser(e) {
      this.currentId = e.id
      this.selectedNode = e
      let select = e.users || []
      // 去掉不可编辑的人员 过滤掉数组中disabled为true的数组
      // let canEdit = select.filter(e=>!e.disabled)
      // 不可修改的用户
      this.defaultUserIds= select.filter(e=>e.disabled).map(e=>e.id)
      // console.log('canEdit>>',canEdit,'defaultUserIds',this.defaultUserIds)
      this.$refs.orgPicker.show(select,'user')
    },
    // 删除索引是index的用户
    delUser(arr,index,nodeId){
      arr.splice(index, 1);
      this.processUsers[nodeId] = arr;
      console.log('>>',)
    },
    // delUser(e, t) {
    //   e.splice(t, 1);
    //   this.processUsers = e;
    // },
    startProcess() {
      this.cc = [];
      this.getProcess(this.form.process, this.activities, this.cc);

      // this.cc.push({
      //   title: "结束",
      //   name: "END",
      //   icon: "el-icon-success",
      //   isEdit: false,
      // });
    },
    selected(newsUsers) {
      if (newsUsers && newsUsers.length > 0) {
        this.cc.forEach(e=>{
          if(e.id === this.currentId){
            e.isEmpty = false
          }
        })
      }
      // console.log('选择了>>',this.currentId,newsUsers)
      // var t = this;
      // t.processUsers[t.selectedNode.id] = [];

      // e.forEach((user) => {
      //   var ddd = t.selectedNode.users.findIndex((t) => {
      //     return t.id === user.id;
      //   });
      //   if (ddd === -1) {
      //     t.selectedNode.users.push(user);
      //     t.processUsers[t.selectedNode.id]=e;
      //     t.$set(e, "isEdit", true);
      //   }
      // });
      // 过滤掉 this.defaultUserIds 包含的 ID
      newsUsers = newsUsers.filter(user => !this.defaultUserIds.includes(user.id));
      newsUsers.forEach(e => {
        e.isEdit = true
      })
      // const  defaultUser = this.selectedNode.users.filter(e=>e.disabled) // 不可修改的用户
      const defaultUser = (this.selectedNode && this.selectedNode.users) ? this.selectedNode.users.filter(e => e.disabled) : []; // 不可修改的用户
      this.selectedNode.users = [...defaultUser,...newsUsers]
      this.processUsers[this.selectedNode.id] = this.selectedNode.users
      console.log('>>',this.selectedNode.users)
    },
    async getProcess(process, data, cc) {
      if (null != process && undefined != process) {
        if ("ROOT" === process.type) {
          //发起人节点
          this.getRootNode(cc, process);
        } else if ("APPROVAL" === process.type) {
          //审批节点
          await this.getApprovalNode(cc, process);
        } else if ("TASK" === process.type) {
          //办理节点
          await this.getTaskNode(cc, process);
        } else if ("CC" === process.type) {
          await this.getCcNode(cc, process);
        } else if ("CONDITIONS" === process.type) {
          //判断是否符合条件符合走条件分支,否则继续递归子分支
          if (null != process.branchs && undefined != process.branchs) {
            this.getConditionNode(cc, process);
          }
        } else if ("CONCURRENTS" === process.type) {
          this.getConcurrentNode(cc, process);
        }
        if (null != process.children && undefined != process.children) {
          this.getProcess(process.children, data, cc);
        }
       
      }
    },
    // 未找到审批人办理人
    setNoUser(nobody) {
      let text
      if (nobody.handler==='TO_PASS') {
        text = '将自动通过'
      }else if (nobody.handler==='TO_REFUSE') {
        text = '将自动拒绝'
      }else if (nobody.handler==='TO_ADMIN') {
        text = '将自动转交管理员'
      }else if (nobody.handler==='TO_USER') {
        text = '将自动转交给指定成员 '+nobody.assignedUser[0].serial + nobody.assignedUser[0].name
      }
      return text
    },
    //封装开始节点
    getRootNode(cc, process) {
      cc.push({
        id: process.id,
        title: process.name,
        name: "发起人",
        type:process.type,
        icon: "el-icon-user-solid",
        isEdit: false,
        users: [this.loginUser],
      });
    },
    //封装审批节点
    async getApprovalNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        name: "审批人",
        type:process.type,
        icon: "el-icon-s-check",
        isEdit: false,
        multiple: false,
        mode: process.props.mode,
        users: [],
        desc: "",
        level: process.props.leader.level,
      };
      let ids,userList,userCount
      //判断审批人类型
      switch (process.props.assignedType) {
        case "ASSIGN_USER":
          data.users = this.$deepCopy(process.props.assignedUser);
          data.desc = "指定审批人";
          break;
        case "ASSIGN_LEADER":
          data.desc = "指定部门的领导";
          break;
        case "SELF":
          data.users = [this.loginUser];
          data.desc = "发起人自己审批";
          break;
        case "SELF_SELECT":
          data.isEdit = true;
          data.multiple = process.props.selfSelect.multiple || false;
          data.desc = "自选审批人";
          break;
        case "LEADER_TOP":
          data.desc = "连续多级主管审批";
          break;
        case "LEADER":
          userList = await this.checkUser('leader')
          userCount = userList.length
          data.users = this.$deepCopy(userList);
          data.desc = (1 === process.props.leader.level) ? "直接上级" : "第".concat(process.props.leader.level, "级主管");
          if (userCount===0) {
              data.nobodyTitle = '未找到审批人'
              data.nobodyText = this.setNoUser(process.props.nobody)
          }
          console.log('>>',data)
          // data.desc =
          //   1 === process.props.leader.level
          //     ? "直接上级"
          //     : "第".concat(process.props.leader.level, "级主管审批");
          break;
        case "DEPT_LEADER":
          userList = await this.checkUser('dept',data.level)
          userCount = userList.length
          data.users = this.$deepCopy(userList);
          data.desc = (1 === process.props.leader.level) ? "直接上级" : "第".concat(process.props.leader.level, "级主管");
          if (userCount===0) {
              data.nobodyTitle = '未找到审批人'
              data.nobodyText = this.setNoUser(process.props.nobody)
          }
          console.log('dept>>',data)
          break;
        case "ROLE":
          let ids = process.props.role.map(item => item.id)
          userList = await this.checkUser('role',ids)
          userCount = userList.length
          data.users = this.$deepCopy(userList);
          if (userCount===0) {
              data.desc = "指定角色"
              data.nobodyTitle = '未找到审批人'
              data.nobodyText = this.setNoUser(process.props.nobody)
          }
          // console.log('user',user)
          // data.desc = "由角色[".concat(
          //   (process.props.role || []).map(function (e) {
          //     return e.name;
          //   }),
          //   "]审批"
          // );
          break;
        case "REFUSE":
          data.desc = "流程此处将被自动驳回";
          break;
      }
      cc.push(data);
    },
    //封装办理人节点
    async getTaskNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        name: "办理人",
        type:process.type,
        icon: "el-icon-s-check",
        isEdit: false,
        multiple: false,
        mode: process.props.mode,
        users: [],
        desc: "",
        level: process.props.leader.level,
      };
      let ids,userList,userCount
      //判断办理人类型
      switch (process.props.assignedType) {
        case "ASSIGN_USER":
          data.users = this.$deepCopy(process.props.assignedUser);
          data.desc = "指定办理人";
          break;
        case "ASSIGN_LEADER":
          data.desc = "指定部门的领导";
          break;
        case "SELF":
          data.users = [this.loginUser];
          data.desc = "发起人自己办理";
          break;
        case "SELF_SELECT":
          data.isEdit = true;
          data.multiple = process.props.selfSelect.multiple || false;
          data.desc = "自选办理人";
          break;
        case "LEADER_TOP":
          data.desc = "连续多级主管办理";
          break;
        case "LEADER":
          userList = await this.checkUser('leader')
          userCount = userList.length
          data.users = this.$deepCopy(userList);
          data.desc = (1 === process.props.leader.level) ? "直接上级" : "第".concat(process.props.leader.level, "级主管");
          if (userCount===0) {
            data.nobodyTitle = '未找到办理人'
            data.nobodyText = this.setNoUser(process.props.nobody)
          }
          break;
        case "DEPT_LEADER":
          userList = await this.checkUser('dept',data.level)
          userCount = userList.length
          data.users = this.$deepCopy(userList);
          data.desc = (1 === process.props.leader.level) ? "直接上级" : "第".concat(process.props.leader.level, "级主管");
          if (userCount===0) {
              data.nobodyTitle = '未找到办理人'
              data.nobodyText = this.setNoUser(process.props.nobody)
          }
          console.log('dept>>',data)
          break;
        case "ROLE":
          ids = process.props.role.map(item => item.id)
          userList = await this.checkUser('role',ids)
          userCount = userList.length
          data.users = this.$deepCopy(userList);
          if (userCount===0) {
              data.desc = "指定角色"
              data.nobodyTitle = '未找到办理人'
              data.nobodyText = this.setNoUser(process.props.nobody)
          }
          // data.desc = "由角色[".concat(
          //   (process.props.role || []).map(function (e) {
          //     return e.name;
          //   }),
          //   "]办理"
          // );
          break;
        case "REFUSE":
          data.desc = "流程此处将被自动驳回";
          break;
      }
      cc.push(data);
    },
    async getCcNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        icon: "el-icon-s-promotion",
        name: "抄送人",
        type:process.type,
        isEdit: process.props.shouldAdd,
        shouldAdd:process.props.shouldAdd,
        // type: "org",
        multiple: true,
        desc: process.props.shouldAdd ? "可添加抄送人" : "指定抄送人",
        users:[],//人员
        defaultUsers:[],// 不可编辑的人员
        level: process.props.leader && process.props.leader.level,
        // users: this.$deepCopy(process.props.assignedUser),
      };
      let ids,userList,userCount
      //判断抄送人类型
      switch (process.props.assignedType) {
        case "ASSIGN_USER":
          // data.users = this.$deepCopy(process.props.assignedUser);
          // data.desc = "指定抄送人";
          // 可添加抄送人，原角色不可修改
          if (process.props.shouldAdd) {
            data.users = this.notEdit(this.$deepCopy(process.props.assignedUser));
          }else{
            data.users = this.$deepCopy(process.props.assignedUser);
          }
          break;
        case "ASSIGN_LEADER":
          data.desc = "指定部门的领导";
          break;
        case "LEADER_TOP":
          data.desc = "连续多级主管办理";
          break;
        case "LEADER":
          userList = await this.checkUser('leader')
          userCount = userList.length
          console.log('user',userCount)
          // 可添加抄送人，原角色不可修改
          if (process.props.shouldAdd) {
            data.users = this.notEdit(this.$deepCopy(userList));
          }else{
            if(userCount==0){
              data.desc = "抄送0人";
            }else{
              data.users = this.$deepCopy(userList);
            }
          }
          break;
        case "DEPT_LEADER":
          userList = await this.checkUser('dept',data.level)
          userCount = userList.length
          console.log('user',userCount)
          // 可添加抄送人，原角色不可修改
          if (process.props.shouldAdd) {
            data.users = this.notEdit(this.$deepCopy(userList));
          }else{
            if(userCount==0){
              data.desc = "抄送0人";
            }else{
              data.users = this.$deepCopy(userList);
            }
          }
          break;
        case "ROLE":
          ids = process.props.role.map(item => item.id)
          userList = await this.checkUser('role',ids)
          userCount = userList.length
          // console.log('user',user)
          // 可添加抄送人，原角色不可修改
          if (process.props.shouldAdd) {
            data.users = this.notEdit(this.$deepCopy(userList));
          }else{
            if(userCount==0){
              data.desc = "抄送0人";
            }else{
              data.users = this.$deepCopy(userList);
            }
          }
          // data.desc = "指定角色";
          // data.desc = "由角色[".concat(
          //   (process.props.role || []).map(function (e) {
          //     return e.name;
          //   }),
          //   "]抄送"
          // );
          break;
      }
      cc.push(data);
    },
    getConditionNode(cc, process) {
      for (var r = null, s = 0; s < process.branchs.length; s++) {
        for (
          var a = process.branchs[s], n = false, o = 0, i = 0;
          i < a.props.groups.length;
          i++
        ) {
          if (
            ((n = this.getConditionResultByGroup(a.props.groups[i])),
            "OR" === a.props.groupsType && n)
          ) {
            r = a;
            break;
          }
          "AND" === a.props.groupsType && n && o++;
        }

        if (r) {
          break;
        }
        if (o === a.props.groups.length) {
          r = a;
          break;
        }
      }
      var d = [];
      console.log(
        "符合分支条件,继续执行递归,获取符合条件下节点下的子节点!" +
          JSON.stringify(r)
      );
      r
        ? this.getProcess(r, d, cc)
        : console.log(
            "条件节点 "
              .concat(process.id, " => ")
              .concat(process.name, " 均不满足，无法继续"),
            process
          );
    },
    getConcurrentNode(cc, process) {
      var data = {
        id: process.id,
        title: process.name,
        name: "并行分支",
        icon: "el-icon-s-operation",
        isEdit: false,
        active: process.branchs[0].id,
        options: [],
        desc: "切换分支可显示对应执行流程",
        branchs: {},
      };
      cc.push(data);
      process.branchs.forEach((b) => {
        data.options.push({ id: b.id, title: b.name });
        this.$set(data.branchs, b.id, []);
        var d = [];
        this.getProcess(b.children, d, data.branchs[b.id]);
      });
    },
    getConditionResultByGroup: function (e) {
      var t = this,
        r = !1,
        s = 0;
      e.conditions.forEach(function (e) {
        return t.conditionFormItem.add(e.id);
      });

      for (var a = 0; a < e.conditions.length; a++) {
        var n = e.conditions[a];
        switch (n.valueType) {
          case "Number":
            console.log("这是number类型判断");
            r = this.numberCompare(n);
            break;
          case "String":
            console.log("这是string类型判断");
            break;
          case "Date":
            console.log("这是data类型判断");

            break;
          case "User":
            console.log("这是user类型判断");

            break;
          case "Array":
            console.log("这是array类型判断");

            break;
        }
        if (r && "OR" === e.groupType) break;
        r && "AND" === e.groupType && s++;
      }
      return "AND" === e.groupType && (r = s === e.conditions.length), r;
    },
    numberCompare: function (e) {
      var t = this.formData[e.id];
      switch (e.compare) {
        case ">":
          return t > parseFloat(e.value[0]);
        case "<":
          return t < parseFloat(e.value[0]);
        case "=":
          return t === parseFloat(e.value[0]);
        case ">=":
          return t >= parseFloat(e.value[0]);
        case "<=":
          return t <= parseFloat(e.value[0]);
        case "B":
          return t > parseFloat(e.value[0]) && t < parseFloat(e.value[1]);
        case "AB":
          return t >= parseFloat(e.value[0]) && t < parseFloat(e.value[1]);
        case "BA":
          return t > parseFloat(e.value[0]) && t <= parseFloat(e.value[1]);
        case "ABA":
          return t >= parseFloat(e.value[0]) && t <= parseFloat(e.value[1]);
        case "IN":
          return e.value.indexOf(String(t)) > -1;
        default:
          return !1;
      }
    },
    lookMore(list){
      this.$refs.popUserMore.show(list)
    },
    // 根据角色、上级、部门返回人员
    async checkUser(type, ids) {
        let postData = {}
        let APIURL = 'userLookup'
        if (type === 'role') {
          postData.roleIds = ids
          // 没有角色ID就不发请求
          if (ids.length === 0) return false
        } else if (type === 'leader') {
          postData.userId = sessionStorage.getItem("user_id"),
          postData.findSupervisor = true
        }else if (type === 'dept') {
          postData.level = ids
          APIURL = 'userLookLevel'
        }
        try {
          const res = await this.$api[APIURL](postData)
          if (res.code === 0 && res.data?.userDetails) {
            let userList = res.data.userDetails
            userList.forEach(item => {
              if(item.userName){
                let temp = this.splitString(item.userName)
                item.name = temp.name
                item.serial = temp.serial
              }
              if(!item.type){
                item.type = 'user'
              }
            })
            return userList // 这里需要return才能被await接收到
          }
          return [] // 确保有默认返回值
        } catch (error) {
          console.error('查询用户失败:', error)
          return []
        }
      },
    // 把数组每项变为不可编辑
    notEdit(list){
      if (Array.isArray(list) && list.length > 0) {
          return list.map(item => {
          item.disabled = true
          return item
        }) 
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.process-form {
  /deep/ .el-form-item__label {
    padding: 0 0;
    color: #2F3030;
  }
}

.task {
  /* height: 60px; */
  min-height: 110px;
}

.el-timeline-item .el-timeline-item__content .process-node-render > div {
  position: absolute;
  display: inline-block;
}

.el-timeline-item
  .el-timeline-item__content
  .process-node-render
  > div:last-child {
  right: 0;
  top: -10px;
}

.avatar {
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
}

.show-y {
  justify-content: center;
  flex-direction: column !important;
}

.show-y,
.w-h-center {
  display: flex;
  align-items: center;
}

.avatar .a-img {
  display: flex;
  border-radius: 50%;
  flex-direction: column;
  justify-content: center;
  background: #fff;
  position: relative;
}

/* .close {
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  cursor: pointer;
  border-radius: 50%;
  background: #000;
} */

.status {
  position: absolute;
  bottom: -4px;
  right: -8px;
  border-radius: 50%;
  font-size: 15px;
  background: #fff;
  border: 2px solid #fff;
}

.avatar .name {
  text-align: center;
  color: #19191a;
  font-size: 14px;
  margin-left: 10px;
}

.show-y .name {
  margin-left: 0 !important;
}

.line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* .add-user {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.add-user i {
  padding: 10px;
  font-size: 1.1rem;
  border-radius: 50%;
  border: 1px dashed #8c8c8c;
  cursor: pointer;
} */

.el-timeline-item .el-timeline-item__icon {
  color: #babcc1;
  font-size: 16px;
}

.border .el-dialog__header {
  border-bottom: 1px solid #e8e8e8;
}
/* 右边内容 */
.process-body{
  
}
.process-form-content{
  // border-right: 1px solid #EDF2F2;
  // min-height: calc(100vh - 226px);
  /* background-color: red; */
  box-sizing: border-box;
  padding-right: 100px;
  .process-title{
    font-family: PingFang SC, PingFang SC;
    /* font-weight: bold; */
    font-size: 18px;
    color: #2F3030;
    padding: 6px 0 26px 6px;
    line-height: 1;
    position: relative;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      width: 2px;
      height: 16px;
      background: #00B498;
    }
  }
  .process-remark{
      font-size: 14px;
      margin-bottom: 14px;
      line-height: 1.5;
      text-align: left;
      clear: both;
      color: #f00;
      white-space: pre-wrap;
      word-break: break-word;
    }
  .process-has-description{
    margin-bottom:20px ;
  }
}
/* 左边内容 */
.process-timeline{
  padding: 0 16px;
}
// 右边内容
.title-timeline{
  height: 130px;
  font-family: PingFang SC, PingFang SC;
  font-size: 16px;
  box-sizing: border-box;
  padding-top: 60px;
}
.my-timeline /deep/{
  .el-timeline-item__wrapper{
    top: -20px;
    padding-left: 16px;
  }
  .el-timeline-item__tail{
    border-left: 2px solid #C5C9C9;
    left: 1px;
    top: 9px;
    height: calc(100% - 10px);
    opacity: .5;
  }
  .el-timeline-item__node--large{
    width: 8px;
    height: 8px;
    background: #C5C9C9;
    .el-timeline-item__icon{
      display: none;
    }
  }
  .el-timeline-item__timestamp.is-bottom{
    margin-top: 0;
  }
}
.process-node-content{
  display: flex;
  font-family: PingFang SC, PingFang SC;
  .process-node-title{
    width: 88px;
    flex-shrink: 0;
    padding-top: 12px;
    .node-title{
      font-size: 16px;
      margin-bottom: 2px;
    }
    .node-desc{
      font-size: 16px;
      color: #C5C9C9;
      font-size: 12px;
      padding-right:5px;
    }
  }
  .process-node-con{
    display: inline-flex;
    flex-wrap: wrap;
      .no-user{
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #939696;
        .hot{
          color: #D6223D;
        }
        .item-user{
          width: 56px;
          margin-bottom: 0;
          flex-shrink: 0;
        }
      }
      .item-user{
        width: 70px;
        margin-bottom: 10px;
        /* &:last-child{
          background-color: rebeccapurple;
        } */
        .i-and,.i-or{
          width: 20px;
          height: 20px;
          position: absolute;
          right: 1px;
          top: 14px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #939696;
        }
        .i-and{
          font-size: 18px;
        }
        .i-or{
          font-size: 12px;
        }
      }
    .user-photo{
      position: relative;
      .close{
        position: absolute;
        top: 1px;
        left: 31px;
        color: #fff;
        cursor: pointer;
        border-radius: 50%;
        background: #C5C9C9;
        padding: 1px;
        line-height: 1;
      }
      
    }
    .look-more{
      font-size: 12px;
      color: #00B498;
      cursor: pointer;
    }
    .avatar{
      width: 48px;
      height: 48px;
      border-radius: 8px;
    }
    .name-con{
      font-size: 12px;
      color:#939696;
      line-height: 17px;
    }
    .add-user {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 48px;
      height: 48px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #E3E6E5;
      cursor: pointer;
    }

    .add-user i {
      font-size: 18px;
      
      color: #E3E6E5;
    }
  }
  .process-node-con-single .item-user{
    .i-and,.i-or{
      display: none;
    }
  }

}  .err-tips{
    color:#E23C58 ;
  }

</style>
